import { z } from "zod";

export const modelPathSchema = z.string().regex(/^\/media\/models\/[a-f0-9]{64}\.glb$/);
const vectorSchema = z.tuple([z.number().finite(), z.number().finite(), z.number().finite()]);
export const modelAssetSchema = z
  .object({
    path: modelPathSchema,
    byteSize: z
      .int()
      .positive()
      .max(5 * 1024 * 1024),
    triangles: z.int().positive().max(5000),
    min: vectorSchema,
    max: vectorSchema,
  })
  .refine((v) => v.max.every((n, i) => n > v.min[i as 0 | 1 | 2]), "模型必须具有三维体积");
export const appearanceConfigSchema = z.object({
  modelPath: modelPathSchema,
  dimensionsMm: z.tuple([
    z.number().positive().max(100),
    z.number().positive().max(100),
    z.number().positive().max(100),
  ]),
  threadingAxis: z.enum(["x", "y", "z"]),
});
export const appearanceSchema = appearanceConfigSchema
  .extend({
    asset: modelAssetSchema,
    version: z.int().positive(),
  })
  .refine((v) => v.modelPath === v.asset.path, "模型地址必须一致");
export const appearanceStateSchema = z.object({
  revision: z.int().nonnegative(),
  draft: appearanceSchema.nullable(),
  published: appearanceSchema.nullable(),
  previewed: z.boolean(),
});
export const saveAppearanceSchema = appearanceConfigSchema.extend({
  revision: z.int().nonnegative(),
});
export const appearanceRevisionSchema = z.object({ revision: z.int().positive() });
export const publishAppearanceSchema = appearanceRevisionSchema.extend({
  confirmed: z.literal(true),
});
export const appearanceTicketSchema = z.object({
  ticket: z.string().uuid(),
  expiresAt: z.string().datetime(),
});
export const appearancePreviewSchema = z.object({
  name: z.string(),
  photoPath: z.string().nullable(),
  appearance: appearanceSchema,
});
export type ModelAsset = z.infer<typeof modelAssetSchema>;
export type Appearance = z.infer<typeof appearanceSchema>;
export type AppearanceState = z.infer<typeof appearanceStateSchema>;
export type SaveAppearance = z.infer<typeof saveAppearanceSchema>;
export type AppearanceTicket = z.infer<typeof appearanceTicketSchema>;
export type AppearancePreview = z.infer<typeof appearancePreviewSchema>;
